import { ShieldCheck } from "lucide-react";
import { FeatureTiles } from "./FeatureTiles";
import { defaultFeatures } from "../data/loginFeatures";
import { KlipboardCrmInline } from "@/components/logos/KlipboardCrmInline";
import { CRM } from "@/components/logos/Crm";

export const LeftPanel = () => (
  <div className="flex flex-col gap-[clamp(1.25rem,2.5vh,2.5rem)] p-[clamp(1.5rem,2vw,2.5rem)] w-full h-full pointer-events-auto">

    {/* Klipboard CRM strapline logo */}
    <KlipboardCrmInline iconSize={42} />

    <div>
      <div className="mb-[clamp(1rem,1.5vw,1.5rem)]">
        <h1 className="text-white font-extrabold leading-[1.15] m-0 text-[clamp(1.75rem,3vw,3.5rem)]">
          Selling smarter.
        </h1>
        <h1 className="text-brand-pink font-extrabold leading-[1.15] m-0 text-[clamp(1.75rem,3vw,3.5rem)] flex items-center gap-2 flex-wrap">
          <span>Growing with </span>
          <span className="inline-flex items-center">
            <CRM height={52} iconColor="#ED017F" />
            .
          </span>
        </h1>
        <p className="text-[#9CA3AF] text-[clamp(0.875rem,1.1vw,1.2rem)] leading-[1.6] mt-3 mb-0 hidden xl:block">
          Your complete platform for CRM, sales analysis and business intelligence - giving your team the visibility and tools to grow.
        </p>
      </div>

      <FeatureTiles items={defaultFeatures} />
    </div>

    <div className="flex items-start gap-[0.6rem]">
      <ShieldCheck size={18} className="text-brand-pink shrink-0 mt-0.5" strokeWidth={2} />
      <div>
        <p className="text-white font-semibold text-[clamp(0.75rem,0.9vw,1.05rem)] m-0">
          Secure. Reliable. Trusted by businesses worldwide.
        </p>
        <p className="text-white text-[clamp(0.7rem,0.82vw,0.95rem)] mt-[0.2rem] mb-0">
          Your data is protected with enterprise-grade security.
        </p>
      </div>
    </div>
  </div>
);
